import {createAction} from 'redux-act';

export const GET_ORDER = createAction('orderDetailsV2/GET_ORDER');
export const ORDER_UNMOUNT = createAction('orderDetailsV2/ORDER_UNMOUNT');
export const SET_ORDER_LOADING = createAction(
  'orderDetailsV2/SET_ORDER_LOADING'
);
export const GET_ORDER_SUCCESS = createAction(
  'orderDetailsV2/GET_ORDER_SUCCESS'
);
export const GET_DISPATCH_INFO = createAction(
  'orderDetailsV2/GET_DISPATCH_INFO'
);
export const GET_DISPATCH_INFO_SUCCESS = createAction(
  'orderDetailsV2/GET_DISPATCH_INFO_SUCCESS'
);
export const CHANGE_STATUS = createAction('orderDetailsV2/CHANGE_STATUS');
export const CHANGE_STATUS_SUCCESS = createAction(
  'orderDetailsV2/CHANGE_STATUS_SUCCESS'
);
export const GET_DELIVERY_STATUS = createAction(
  'orderDetailsV2/GET_DELIVERY_STATUS'
);
export const GET_DELIVERY_STATUS_SUCCESS = createAction(
  'orderDetailsV2/GET_DELIVERY_STATUS_SUCCESS'
);
export const CANCEL_DELIVERY_ORDER = createAction(
  'orderDetailsV2/CANCEL_DELIVERY_ORDER'
);
export const OPEN_CANCEL_DELIVERY_ORDER_MODAL = createAction(
  'orderDetailsV2/OPEN_CANCEL_DELIVERY_ORDER_MODAL'
);
export const SET_LOADING_CANCELLATION = createAction(
  'orderDetailsV2/SET_LOADING_CANCELLATION'
);
export const OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL = createAction(
  'orderDetailsV2/OPEN_CANCEL_DELIVERY_ORDER_RESULT_MODAL'
);

export const RATE_DRIVER = createAction('orderDetailsV2/RATE_DRIVER');
export const RATE_DRIVER_SUCCESS = createAction(
  'orderDetailsV2/RATE_DRIVER_SUCCESS'
);
export const RATE_DRIVER_ERROR = createAction(
  'orderDetailsV2/RATE_DRIVER_ERROR'
);
export const GET_DRIVER_RATING = createAction(
  'orderDetailsV2/GET_DRIVER_RATING'
);
export const GET_DRIVER_RATING_SUCCESS = createAction(
  'orderDetailsV2/GET_DRIVER_RATING_SUCCESS'
);
export const GET_DRIVER_RATING_ERROR = createAction(
  'orderDetailsV2/GET_DRIVER_RATING_ERROR'
);
export const UPDATE_DRIVER_RATING = createAction(
  'orderDetailsV2/UPDATE_DRIVER_RATING'
);
export const UPDATE_DRIVER_RATING_SUCCESS = createAction(
  'orderDetailsV2/UPDATE_DRIVER_RATING_SUCCESS'
);
export const UPDATE_DRIVER_RATING_ERROR = createAction(
  'orderDetailsV2/UPDATE_DRIVER_RATING_ERROR'
);
export const DELETE_DRIVER_RATING = createAction(
  'orderDetailsV2/DELETE_DRIVER_RATING'
);
export const DELETE_DRIVER_RATING_SUCCESS = createAction(
  'orderDetailsV2/DELETE_DRIVER_RATING_SUCCESS'
);
export const DELETE_DRIVER_RATING_ERROR = createAction(
  'orderDetailsV2/DELETE_DRIVER_RATING_ERROR'
);

export const SET_DELIVERY_STATUS_LOADING = createAction(
  'orderDetailsV2/SET_DELIVERY_STATUS_LOADING'
);

export const CLEAR_ORDER = createAction('orderDetailsV2/CLEAR_ORDER');
export const GET_BAD_ORDERS_BY_CORE = createAction(
  'orderDetailsV2/GET_BAD_ORDERS_BY_CORE'
);
export const SET_BAD_ORDERS_BY_CORE = createAction(
  'orderDetailsV2/SET_BAD_ORDERS_BY_CORE'
);
